import { render, staticRenderFns } from "./plan_for_you.vue?vue&type=template&id=50009f5f&scoped=true"
import script from "./plan_for_you.vue?vue&type=script&lang=js"
export * from "./plan_for_you.vue?vue&type=script&lang=js"
import style0 from "./plan_for_you.vue?vue&type=style&index=0&id=50009f5f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50009f5f",
  null
  
)

export default component.exports